import React from 'react';
import telegramIcon from '../assets/telegram.png';
import twitterIcon from '../assets/x.png';
import './Footer.css';
import love from '../assets/love.png';
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">POTUS</h3>
            <p className="footer-description">Make Crypto Great Again</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Community</h3>
            <div className="footer-social-links">
              <a
                href="https://t.me/potus2025sol"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={telegramIcon}
                  alt="Telegram"
                  className="footer-icon"
                />
              </a>
              <a
                href="https://x.com/potus2025sol"
                target="_blank"
                rel="noopener noreferrer">
                <img src={twitterIcon} alt="Twitter" className="footer-icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <img
            src={love}
            alt="love"
            className="love"
            height="90px"
            width="90px"
            style={{
              marginLeft: "10px",
              marginTop: "5px",
              left: "2px",
              position: "relative",
            }}
          />
          <p className="copyright">
            © {new Date().getFullYear()} POTUS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 